module.exports = __webpack_public_path__ + "media/images/blue-dropdown-9e0938bf88ec053a5d7bb58d79773537.svg";